import { ManageSubscription } from "features/subscriptions/components";
import useManageSubscriptionSteps from "features/subscriptions/hooks/useManageSubscriptionSteps";
import type { MixpanelSubscriptionSource } from "features/subscriptions/types";

import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type {
  AgencySubscription,
  RentedSubscription,
  Subscription,
  SubscriptionType,
} from "common/types";

interface ManageSubscriptionDialogProps {
  initialState:
    | {
        subscription: AgencySubscription | Subscription | RentedSubscription;
        seats: number;
      }
    | SubscriptionType;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  mixpanelSource: MixpanelSubscriptionSource;
}

export default function ManageSubscriptionDialog({
  isOpen,
  setIsOpen,
  initialState,
  mixpanelSource,
}: ManageSubscriptionDialogProps) {
  const isDesktop = useTwBreakpoint("lg");
  const {
    manageSubscriptionStep,
    goToManageSubscriptionStep,
    resetManageSubscriptionStep,
    dialogSize,
  } = useManageSubscriptionSteps(initialState, isOpen);

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component
      open={isOpen}
      onOpenChange={setIsOpen}
      onAfterClose={resetManageSubscriptionStep}
    >
      <Content size={dialogSize}>
        <ManageSubscription
          initialState={initialState}
          step={manageSubscriptionStep}
          goToStep={goToManageSubscriptionStep}
          mixpanelSource={mixpanelSource}
        />
      </Content>
    </Component>
  );
}
